<template>
  <div v-if="question">

    <template v-if="relatedQuest && (relatedQuest.private || relatedQuest.pending) && (relatedQuest.private.length > 0 || relatedQuest.pending.length > 0)">
      <v-expansion-panels>
        <template v-for="(quest, index) in relatedQuest.private">
          <AskAccordion v-if="quest[`question_${$i18n.locale}`] !== ''" :key="`privateq-${index}`" :question="quest" type="private"></AskAccordion>
        </template>
        
        <template v-for="(quest, index) in relatedQuest.pending">
          <AskAccordion v-if="quest[`question_${$i18n.locale}`] !== ''" :key="`pendingq-${index}`" :question="quest" type="pending"></AskAccordion>
        </template>
      </v-expansion-panels>
    </template>

    <template v-if="!noButton">
      <v-btn
        color="primary"
        elevation="0"
        rounded
        outlined
        small
        @click="dialog = true"
      >{{ $t("ask-box.btn-1") }}</v-btn>

      <v-dialog
        v-model="dialog"
        max-width="620"
      >
        <AskHelpModal
          @dialogToParent="closeDialog"
          :dialog="dialog"
          :keywords="`${question.id}|${$route.params.answerid}`"
          :context="question[`title_${$i18n.locale}`]"
          @alert="showAlert"
        ></AskHelpModal>
        <!-- <AskHelpModal
          @dialogToParent="closeDialog"
          :dialog="dialog"
          :keywords="`${question.id}|${keywordid}|${$route.params.answerid}`"
          @alert="showAlert"
        ></AskHelpModal> -->

        <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
        <v-snackbar
          v-model="alert"
          color="#161520"
          :timeout="6000"
          top
          multi-line
        >
          <span v-html="alertMessage"></span>
          <v-btn
            dark
            text
            :color="alertType === 'error' ? '#f12d57' : '#44d22d'"
            @click="alert = false"
          >
            {{ $t("ask-box.snackbar.btn-1") }}
          </v-btn>
        </v-snackbar>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { getQuestions } from '@/js/questions/getQuestions'
// import { askQuestion } from '@/js/questions/askQuestion'
import AskHelpModal from '@/components/questions/AskHelpModal'
import AskAccordion from '@/components/audits/survey/AskAccordion'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    AskHelpModal: AskHelpModal,
    AskAccordion: AskAccordion,
    HTTPresponse: HTTPresponse
  },

  props: {
    question: Array | Object,
    keywordid: String,
    noButton: {
      type: Boolean,
      default: () => false
    },
    inspector: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      relatedQuest: null,

      dialog: false,
      keywords: null,
      page: null,

      alert: false,
      alertType: 'error',
      alertMessage: this.$t('basic-message.error-message'),

      httpalert: false
    }
  },

  created () {
    // if (this.$store.getters['auth/isAuthenticated!']) return

    this.$root.$on('disableInterceptor')

    const params = {
      keywords: `${this.question.id}|${this.$route.params.answerid}`,
      // page: 'all',
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      key: this.inspector && this.$route.params.validkey ?
           this.$route.params.validkey : this.$store.state.auth.token,
      questionType: 'all'
    }

    getQuestions(params)
      .then(response => {
        this.relatedQuest = response
        this.$root.$on('enableInterceptor')
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })
  },

  methods: {
    closeDialog (value) {
      this.dialog = value
    },
    showAlert (response) {
      this.alert = response.alert
      this.alertType = response.alertType
      this.alertMessage = response.alertMessage
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
